<template>
    <div>
        <section class="cabinet-panel d-none d-lg-flex flex-justify-sb mb-0">
            <div class="cabinet-filter">
                <div class="cabinet-filter__line d-flex">
                    <div
                        :class="{ active: filter === 'all' }"
                        class="cabinet-filter__item"
                        @click="setFilter('all')"
                    >
                        Все
                    </div>
                    <div
                        v-if="isRetailer"
                        class="cabinet-filter__item"
                        :class="{ active: filter === 'favourite' }"
                        @click="setFilter('favourite')"
                    >
                        <div class="icon-star"></div>
                    </div>

                    <div
                        v-for="char of engChars"
                        :key="char"
                        :class="{ active: filter === char }"
                        class="cabinet-filter__item"
                        @click="setFilter(char)"
                    >
                        {{ char }}
                    </div>

                    <div
                        :class="{ active: filter === 'num' }"
                        class="cabinet-filter__item"
                        @click="setFilter('num')"
                    >
                        0-9
                    </div>
                </div>
                <div class="cabinet-filter__line d-flex">
                    <div
                        v-for="char of rusChars"
                        :key="char"
                        :class="{ active: filter === char }"
                        class="cabinet-filter__item"
                        @click="setFilter(char)"
                    >
                        {{ char }}
                    </div>
                </div>
            </div>
        </section>

        <div
            class="flex flex-column flex-justify-sb mobile-filter"
            :class="{ 'mobile-filter--open': mFilterOpen }"
        >
            <div class="mobile-filter__wrap">
                <div
                    class="flex flex-justify-sb flex-align-center mobile-filter__header"
                >
                    <div class="h3 mobile-filter__title">
                        Бренды
                        <span class="mobile-filter__selected-count"></span>
                    </div>
                    <button
                        type="button"
                        class="mobile-filter__close-btn"
                        @click="$emit('onCloseMFilter')"
                    ></button>
                </div>

                <ul class="mobile-filter__list">
                    <li class="mobile-filter__list-item">
                        <label class="radio-right">
                            <input
                                v-model="mFilterVal"
                                type="radio"
                                name="brand"
                                value="all"
                            />
                            <span class="radio-right__checkmark"></span>
                            Все бренды
                        </label>
                    </li>
                    <li v-if="isRetailer" class="mobile-filter__list-item">
                        <label class="radio-right">
                            <input
                                v-model="mFilterVal"
                                type="radio"
                                name="brand"
                                value="favourite"
                            />
                            <span class="radio-right__checkmark"></span>
                            <span class="v2-retailer-brands__radio-label"
                                >Только избранные</span
                            >
                        </label>
                    </li>
                    <li class="mobile-filter__list-item">
                        <div class="v2-retailer-brands__radio-group">
                            Бренды на букву
                        </div>
                    </li>

                    <li
                        v-for="char of engChars"
                        :key="char"
                        class="mobile-filter__list-item"
                    >
                        <label class="radio-right">
                            <input
                                v-model="mFilterVal"
                                type="radio"
                                name="brand"
                                :value="char"
                            />
                            <span class="radio-right__checkmark"></span>
                            {{ char }}
                        </label>
                    </li>

                    <li class="mobile-filter__list-item">
                        <label class="radio-right">
                            <input
                                v-model="mFilterVal"
                                type="radio"
                                name="brand"
                                value="num"
                            />
                            <span class="radio-right__checkmark"></span>
                            0-9
                        </label>
                    </li>

                    <li
                        v-for="char of rusChars"
                        :key="char"
                        class="mobile-filter__list-item"
                    >
                        <label class="radio-right">
                            <input
                                v-model="mFilterVal"
                                type="radio"
                                name="brand"
                                :value="char"
                            />
                            <span class="radio-right__checkmark"></span>
                            {{ char }}
                        </label>
                    </li>
                </ul>
            </div>

            <div class="d-flex p-3 mobile-filter__footer">
                <button
                    type="button"
                    class="cabinet-btn mr-3"
                    @click="$emit('onCloseMFilter')"
                >
                    Показать
                </button>
                <button
                    type="button"
                    class="cabinet-btn cabinet-btn--default js-close-filter-btn"
                    @click="resetFilters"
                >
                    Сбросить
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

let engChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
let rusChars = 'АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ'

export default {
    name: 'BrandsFilters',
    props: {
        filter: {
            type: String,
            required: true
        },
        mFilterOpen: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            engChars,
            rusChars
        }
    },
    computed: {
        mFilterVal: {
            get() {
                return this.filter
            },
            set(value) {
                this.setFilter(value)
            }
        },
        ...mapGetters('user', ['isRetailer'])
    },
    methods: {
        setFilter(filter) {
            this.$emit('onChangeFilter', filter)
        },
        resetFilters() {
            this.setFilter('')
            this.$emit('onCloseMFilter')
        }
    }
}
</script>
